import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import WebsiteDisclaimer from "./pages/WebsiteDisclaimer";
import RefundPolicy from "./pages/RefundPolicy";
import DeliveryGuide from "./pages/DeliveryGuide";
import ForShops from "./pages/ForShops";
import AdminDashboard from "./pages/AdminDashboard";
import PaymentPage from "./pages/PaymentPage";
import SydneyGuide from "./pages/SydneyGuide";
import MelbourneGuide from "./pages/MelbourneGuide";
import BrisbaneGuide from "./pages/BrisbaneGuide";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/disclaimer" element={<WebsiteDisclaimer />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="/guide" element={<DeliveryGuide />} />
          <Route path="/how-to-start-delivery-australia" element={<DeliveryGuide />} />
          <Route path="/how-to-start-delivery-sydney" element={<SydneyGuide />} />
          <Route path="/how-to-start-delivery-melbourne" element={<MelbourneGuide />} />
          <Route path="/how-to-start-delivery-brisbane" element={<BrisbaneGuide />} />
          <Route path="/for-shops" element={<ForShops />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/payment/:submissionId" element={<PaymentPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
